import imgtitelbild0600 from "./standalone/titelbild0600.jpg"
import imgtitelbild0800 from "./standalone/titelbild0800.jpg"
import imgtitelbild1000 from "./standalone/titelbild1000.jpg"
import imgtitelbild1600 from "./standalone/titelbild1600.jpg"
let titelbild = [imgtitelbild0600, imgtitelbild0800, imgtitelbild1000, imgtitelbild1600];
export default titelbild;



// WEBPACK FOOTER //
// ./src/images/titelbild.js